import React from "react";
import ContactForm from "../../components/ContactForm/ContactForm";
import GoogleMap from "../../components/GoogleMap/GoogleMap";
import GoogleMapReact from "google-map-react";
import { GrMapLocation } from "react-icons/gr";

const Contattaci = () => {
  const AnyReactComponent = ({ text }) => (
    <div
      className="gmap-pointer"
      style={{
        width: "50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "26px",
        textAlign: "center",
        lineHeight: "50px",
        borderRadius: "100%",
        backgroundColor: "white",
        padding: "10px",
      }}
    >
      <GrMapLocation />
    </div>
  );

  const defaultProps = {
    center: {
      lat: 45.847156993192826,
      lng: 10.14042911376233,
    },
    zoom: 14,
  };

  return (
    <div>
      <div style={{ height: "500px", width: "100%" }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyACeDvsYfEiOsXB8hmSz82GaoIjmjsFbgw" }}
          defaultCenter={defaultProps.center}
          defaultZoom={defaultProps.zoom}
        >
          <AnyReactComponent
            lat={45.847156993192826}
            lng={10.14042911376233}
            text="My Marker"
          />
        </GoogleMapReact>
      </div>
      <div className="pt pb">
        <div className="container">
          <div className="intro mb2">
            <h2 >Contattaci</h2>
            <p className="mb0">
              Se vuoi richiedere un preventivo o non hai ancora definito a pieno
              il tuo progetto, non esitare a contattarci, basta un minuto e ti
              rispondiamo con rapidità.
            </p>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contattaci;
